<template>
  <ProtocolPage type="user" />
</template>

<script>
import ProtocolPage from '../ProtocolPage.vue'

export default {
  name: 'UserProtocol',
  components: {
    ProtocolPage
  }
}
</script>
